// noinspection DuplicatedCode

import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import DialogForm from '@/modules/common/components/DialogForm';
import { withFetch } from '~/hocs/fetch';
import Form from './Form';

const initialValues = {
    url: '',
};

const initialErrors = {
    url: '',
};

let abortController;

const DialogEdit = (props) => {
    const [values, setValues] = useState(initialValues);
    const [errors, setErrors] = useState(initialErrors);
    const [fetching, setFetching] = useState(false);

    const clear = () => {
        setValues(initialValues);
        setErrors(initialErrors);
    };

    useEffect(() => {
        return () => {
            if (abortController) {
                abortController.abort();
            }
        };
    }, []);

    useEffect(() => {
        if (props.selectedLanding) {
            setValues({url: props.selectedLanding.url});
        }
    }, [props.selectedLanding]);

    const handleSubmit = (event) => {
        abortController = new AbortController();
        event.preventDefault();
        setFetching(true);
        props.fetch.put(`/api/landings/${props.selectedLanding.id}/`, {url: values.url}, abortController)
            .then(({ok, data}) => {
                if (ok) {
                    clear();
                    props.onOk(data);
                }
                else {
                    let _errors = {...initialErrors};
                    _errors.url = (data.url) ? data.url[0] : '';
                    setErrors(_errors);
                }
                setFetching(false);
            }).catch((error) => {
                if (error.name !== 'AbortError') {
                    setFetching(false);
                }
            }).finally(() => {
                abortController = null;
            });
    };

    const handleClose = () => {
        props.setOpen(false);
        clear();
        props.setSelectedLanding(null);
    };

    return (
        <DialogForm title="Изменение лендинга" label="Изменить"
                    open={props.open} onClose={handleClose}
                    onSubmit={handleSubmit}
                    disabled={fetching}
        >
            <Form values={values} setValues={setValues} errors={errors} setErrors={setErrors}/>
        </DialogForm>
    );
};

DialogEdit.propTypes = {
    selectedLanding: PropTypes.object,
    setSelectedLanding: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired,
    setOpen: PropTypes.func.isRequired,
    onOk: PropTypes.func.isRequired,
};

let Component = DialogEdit;
Component = withFetch(Component);

export default Component;
